const boxShadow = (color, borderSize = '1px') => ({ boxSizing: 'border-box', boxShadow: `inset 0 0 1px ${borderSize} ${color}` })

const inputSelectors = ['.text-field', '.select', '.textarea', 'select']
const allInputSelectors = `& ${inputSelectors.join(', & ')}` // & input, & select...
const hasInputs = inputSelectors.map((x) => `&:has(${x})`).join(', ')
const hasInputsEnabled = inputSelectors.map((x) => `&:has(${x}:enabled)`).join(', ')
const hasInputDisabled = inputSelectors.map((x) => `&:has(${x}:disabled)`).join(', ')

/**
 *
 */
const styles = (t) => {
    const { colors, typography } = t['foundations-library']
    return {
        commonInput: {
            '&.common-input--full-width': {
                width: '100%',
                '& .input-wrapper': { width: '100%' },
                [allInputSelectors]: { width: '100%' }
            },
            '& .input-wrapper': {
                width: '100% !important',
                borderBottom: 0,
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                [hasInputsEnabled]: {
                    '&:hover:not(:focus-within)': {
                        ...boxShadow(colors.neutral[400], '2px')
                    }
                },
                [hasInputs]: {
                    borderRadius: '6px',
                    padding: '0px 10px 0px 14px',
                    ...boxShadow(colors.neutral[400])
                },
                [hasInputDisabled]: {
                    ...boxShadow(colors.neutral[300]),
                    '&::placeholder': {
                        color: colors.neutral[300]
                    },
                    [allInputSelectors]: {
                        color: colors.neutral[300]
                    }
                },
                '&:focus-within, &:has(.input--focused)': {
                    ...boxShadow(colors.neutral[700], '2px'),
                    outline: 'none'
                },
                '&.has-error': {
                    ...boxShadow(colors.destructive[500]),
                    '&:focus-within': {
                        ...boxShadow(colors.destructive[700], '2px')
                    },
                    [hasInputsEnabled]: {
                        '&:hover:not(:focus-within)': {
                            ...boxShadow(colors.destructive[500], '2px')
                        }
                    }
                },
                transition: 'box-shadow 0.2s',
                '& .label-in-border': {
                    position: 'absolute',
                    top: '-6px',
                    left: '14px',
                    backgroundColor: 'white',
                    paddingLeft: '4px',
                    paddingRight: '4px',
                    ...typography.label,
                    color: colors.neutral[500]
                },
                '&.large': {
                    height: '44px',
                    '& .label-in-border': {
                        left: '14px'
                    }
                },
                '&.small': {
                    height: '38px',
                    '& .label-in-border': {
                        left: '10px'
                    }
                },
                '& .clear-input-button': {
                    display: 'none',
                    marginLeft: '6px'
                },
                '&:hover': {
                    '& .clear-input-button': {
                        display: 'inline'
                    }
                },
                '& .leading-icon': {
                    marginRight: '5px',
                    cursor: ({ hasLeadingIconAction, disabled }) => !disabled && hasLeadingIconAction && 'pointer'
                },
                '& .trailing-icon': {
                    marginLeft: '5px',
                    cursor: ({ hasTrailingIconAction, disabled }) => !disabled && hasTrailingIconAction && 'pointer'
                }
            },
            [allInputSelectors]: {
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1,
                border: 'none',
                outline: 'none',

                height: 'fit-content',
                width: '100%',
                ...typography.body2,
                color: colors.neutral[900],
                '&::placeholder': {
                    ...typography.body2,
                    color: colors.neutral[700]
                }
            }
        },
        validationError: {
            marginTop: '7px'
        },
        inputHelperText: {
            ...typography.body4,
            lineHeight: '16px',
            marginTop: '8px',
            display: 'flex',
            alignItem: 'center',
            gap: '5px'
        }
    }
}

export default styles
